import { createFileRoute, redirect } from "@tanstack/react-router";

/* Supplies opens on the calendar; the Kitchen agent is beside it, in the right-hand pane. */
export const Route = createFileRoute("/_authenticated/supplies/")({
  beforeLoad: () => {
    throw redirect({ to: "/supplies/calendar", replace: true });
  },
});
